module.exports = __webpack_public_path__ + "static/media/opd.37480b81.svg";